import { Typography } from "@mui/material";

export const chipPaymentStatus = (status = "Pending") => {

    const PAYMENT_STATUS_CFG = {
        Paid: { bg: "#DCFCE7", fg: "#15803D" }, // emerald green  — fully settled, positive
        Partially: { bg: "#FEF9C3", fg: "#A16207" }, // warm amber     — incomplete, caution
        Pending: { bg: "#E0F2FE", fg: "#0369A1" }, // sky blue       — awaiting payment, neutral
        Refunded: { bg: "#F3E8FF", fg: "#7E22CE" }, // soft purple    — reversed transaction
        
        Overdue: { bg: "#FFE4E6", fg: "#BE123C" }, // rose red       — past due, urgent
        Waived: { bg: "#F3F4F6", fg: "#374151" }, // cool slate     — forgiven / written off
        Failed: { bg: "#FEE2E2", fg: "#DC2626" }, // soft red       — payment attempt failed
    };

    const pmtCfg = PAYMENT_STATUS_CFG[status] ?? { bg: "#F3F4F6", fg: "#374151" };

    return (
        <Typography style={{
            display: "inline-flex",
            padding: "2px 8px",
            borderRadius: 3,
            fontSize: 11,
            fontWeight: 700,
            backgroundColor: pmtCfg.bg,
            color: pmtCfg.fg,
            whiteSpace: "nowrap",
        }}>
            {status}
        </Typography>
    );
};